import { RouteProps } from 'src/router/types';
import { Navigate } from 'react-router-dom';
import MachineGroupMachines from './MachineGroupMachines';
import MachineGroupPresets from './MachineGroupPresets';
import MachineGroupTelemetry from './MachineGroupTelemetry';

const ROUTE_MACHINES = 'machines';
const ROUTE_PRESETS = 'presets';
const ROUTE_TELEMETRY = 'telemetry';

export const routes: RouteProps[] = [
  {
    index: true,
    element: <Navigate to={ROUTE_MACHINES} replace />,
  },
  {
    path: ROUTE_MACHINES,
    element: <MachineGroupMachines />,
    meta: {
      title: 'Machines',
    },
  },
  {
    path: ROUTE_PRESETS,
    element: <MachineGroupPresets />,
    meta: {
      title: 'Presets',
    },
  },
  {
    path: ROUTE_TELEMETRY,
    element: <MachineGroupTelemetry />,
    meta: {
      title: 'Telemetry',
    },
  },
];
